module.exports = __webpack_public_path__ + "static/assets/1f6edff805eca1968b4d615456b1033f.svg";